module.exports = __webpack_public_path__ + "img/stylish_dress.ad0df2c2.jpg";